import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DotPattern } from '../components/layout/DotPattern';
import { Header } from '../components/layout/Header';
import { useAuth } from '../contexts/AuthContext';
import { LoginModal } from '../components/auth/LoginModal';
import { AndroidWebPromoModal } from '../components/AndroidWebPromoModal';

export function PublicLayout() {
    const { user, signOut, loading } = useAuth();
    const location = useLocation();
    const [showLoginModal, setShowLoginModal] = React.useState(false);
    const [authReady, setAuthReady] = React.useState(() => !loading);

    const isAnonymous = user?.userType === 'anonymous';

    React.useEffect(() => {
        if (!loading) {
            setAuthReady(true);
        }
    }, [loading]);

    // Open login modal if query includes login=true
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('login') === 'true') {
            setShowLoginModal(true);
        }
    }, [location.search]);

    if (!authReady) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center relative overflow-hidden">
                <DotPattern className="opacity-60" />
                <div className="text-center relative z-10 max-w-md mx-auto px-4">
                    <div className="relative">
                        <div className="absolute -inset-2 bg-gradient-to-r from-accent-primary to-accent-secondary rounded-full blur-lg opacity-30 animate-pulse-slow" />
                        <img
                            src="/arizacark.webp"
                            alt="Yükleniyor"
                            className="relative h-16 w-16 mx-auto animate-spin"
                        />
                    </div>
                    <p className="mt-6 text-glass-700 font-medium">Hesabınız kontrol ediliyor...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white relative overflow-hidden">
            <DotPattern className="opacity-60" />

            <Header
                userId={user?.id}
                userName={user?.displayName || user?.email || undefined}
                userPhoto={user?.photoURL || undefined}
                isAnonymous={isAnonymous}
                userType={user?.userType}
                userLimits={user?.limits}
                billingProvider={user?.billingProvider}
                premiumPlatform={user?.premiumPlatform}
                dodoCustomerId={user?.dodoCustomerId}
                premiumBonus={user?.premiumBonus}
                storeSubscription={user?.storeSubscription}
                onSignOut={signOut}
                onSignIn={() => setShowLoginModal(true)}
            />

            <main className="relative">
                <Outlet context={{ setShowLoginModal }} />
            </main>

            <LoginModal
                isOpen={showLoginModal}
                onClose={() => setShowLoginModal(false)}
            />
            <AndroidWebPromoModal />
        </div>
    );
}
